import React from 'react';
import { Component } from '@poa/core';
import CalendarsTableHeader from './calendars-table-header';

class CalendarsTable extends React.Component {

  constructor(props) {
    super(props);
    this.localState = { expandedRows: [] };
  }

  onBodyScroll = ({ currentTarget }) => {
    const sidebarEl = this.props.getSidebarElement();
    const headerEl = this.props.getHeaderElement();
  
    if (sidebarEl) {
      sidebarEl.scrollTop = currentTarget.scrollTop;
    }

    if (headerEl) {
      headerEl.scrollLeft = currentTarget.scrollLeft;
    }
  };

  render() {
    const { rates } = this.props;

    return (
      <div>
        <div>
          <div
            ref={node => (this.tableEl = node)}
            style={{ 
              marginTop: '-43px',
              overflowX: 'scroll',
              overflowY: 'scroll',
              height: 'calc(100vh - 200px)',
              maxHeight: 'calc(100vh - 200px)',
           }}
            onScroll={this.onBodyScroll}
          >
            <table>
              <CalendarsTableHeader rates={rates} hidden />
              <tbody>
              {rates.data}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default Component({ namespaces: ['calendar2'] })(CalendarsTable);
